module.exports = __webpack_public_path__ + "static/media/heartipro-2.88bb913e.jpg";